import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getDangerousGoodsList(params) {
  return request({
    url: URL.mdm.basicData.dangerousGoods,
    method: 'get',
    params
  })
}

export function saveDangerousGoods(data) {
  return request({
    url: URL.mdm.basicData.dangerousGoods,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delDangerousGoods(uuid) {
  return request({
    url: URL.mdm.basicData.dangerousGoods + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
